import { requestGet, requestPost, requestGetFilterEmpty, requestFormPost } from '@/common/request';

export default {
  // 素材维护消息触达-商品列表
  // https://cf.jd.com/pages/viewpage.action?pageId=789900041
  async getShopList(data) {
    return await requestFormPost(`/generic/mac/activityMaterial/skuPage`, data);
  },
  // 素材维护消息触达-商品概览
  // https://cf.jd.com/pages/viewpage.action?pageId=789900009
  async getShopData(activityId) {
    return await requestFormPost(`/generic/mac/activityMaterial/skuOverview`, { activityId });
  },
};
